import * as yup from "yup";

export const createProgrammeDescriptorValidation = () => {
  const schema = yup.object().shape({
    pdTitle: yup.string().label("This field").required().max(200),
    countries: yup
      .array()
      .of(yup.string().required())
      .min(1, "This field is required")
      .required("Countries is required"),
    language: yup.string().required("This field is required"),
    owner: yup.string().required("This field is required"),
    duration: yup
      .array()
      .of(yup.string().required())
      .min(1, "This field is required")
      .required("This field is required"),
  });
  return { schema };
};
